<template>
  <Modal
    :value="modalCancelPurchaseIsOpen"
    :onClose="toggleModalCancelPurchase"
    size="tiny"
  >
    <b-row align="center">
      <b-col>
        <AlertCircleOutline class="icon-2x" title="Alerta" />
      </b-col>
    </b-row>
    <b-row align="center" class="mt-2 mb-3">
      <b-col>
        <h2>Tem certeza que deseja excluir?</h2>
      </b-col>
    </b-row>
    <b-row align="center">
      <b-col>
        <Button type="cancel" @click="toggleModalCancelPurchase()">
          <Close class="mb-1" title="Cancelar" /> Cancelar
        </Button>
        <Button @click="handleCancel()" type="success">Confirmar</Button>
      </b-col>
    </b-row>
  </Modal>
</template>

<script>
import { Modal } from '@/components';
import { Button } from '@/components/Form';
import Close from 'vue-material-design-icons/Close';
import AlertCircleOutline from 'vue-material-design-icons/AlertCircleOutline.vue';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'modalCancelPurchase',
  components: {
    Modal,
    Button,
    Close,
    AlertCircleOutline,
  },
  computed: {
    ...mapState('purchase', ['paginationPurchase']),
    ...mapState('componentsPurchase', [
      'modalCancelPurchaseIsOpen',
      'modalCancelPurchaseIds',
    ]),
  },
  methods: {
    ...mapActions('purchase', ['deletePurchase', 'setSummaryPurchases']),
    ...mapActions('application', ['setLoading']),
    ...mapActions('componentsPurchase', ['toggleModalCancelPurchase']),
    async handleCancel() {
      this.setLoading(true);
      await this.deletePurchase(this.modalCancelPurchaseIds);
      await this.setSummaryPurchases({
        search: null,
        pagination: { ...this.paginationPurchase, currentPage: 1 },
      });
      this.setLoading(false);
      this.toggleModalCancelPurchase();
    },
  },
};
</script>

<style scoped>
.icon-2x {
  color: #f8bb86;
  height: 7.5em;
  width: 7.5em;
}

.icon-2x > .material-design-icon__svg {
  height: 7.5em;
  width: 7.5em;
}
</style>
